import React from 'react';
import AlignCenterIcon from 'remixicon-react/AlignCenterIcon.js';
import AlignLeftIcon from 'remixicon-react/AlignLeftIcon.js';
import AlignRightIcon from 'remixicon-react/AlignRightIcon.js';
import { T, useI18n, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { ImagePickerBlockField } from '@tribeplatform/react-components/PickerField';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useBlock } from '../../hooks/index.js';
import { bgImagePositionsFactory, wrapperStylesFactory } from './utils.js';
export const HeroBannerBlockSettings = () => {
    const { block: { props: { title, description, searchPlaceholder, align, image, textColor, imagePosition, backgroundType, style, imageTintOpacity, extraPadding, backgroundColor, }, }, upsertProp, upsertProps, } = useBlock();
    const { $t } = useI18n();
    const wrapperStyles = useStaticIntl(wrapperStylesFactory);
    const bgImagePositions = useStaticIntl(bgImagePositionsFactory);
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(FormControl.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }), value: title, onChange: e => upsertProp('title', e.target.value) }),
        React.createElement(FormControl.Input, { name: "description", label: React.createElement(T, { id: "Generics.Description", defaultMessage: "Description" }), value: description, onChange: e => upsertProp('description', e.target.value) }),
        React.createElement(FormControl.Slider, { label: React.createElement(T, { id: "Generics.Height", defaultMessage: "Height" }), min: 2, max: 10, step: 0.5, name: "extraPadding", value: extraPadding, onChange: value => upsertProp('extraPadding', value) }),
        React.createElement(FormControl.ButtonGroupSelect, { name: "align", label: React.createElement(T, { id: "Generics.TextAlign", defaultMessage: "Text align" }), fullWidth: true, items: [
                {
                    icon: React.createElement(AlignLeftIcon, null),
                    value: 'leading',
                },
                {
                    icon: React.createElement(AlignCenterIcon, null),
                    value: 'center',
                },
                {
                    icon: React.createElement(AlignRightIcon, null),
                    value: 'trailing',
                },
            ], value: align, onChange: (value) => upsertProp('align', value) }),
        React.createElement(FormControl.Select, { name: "style", label: React.createElement(T, { id: "Generics.WrapperStyle", defaultMessage: "Wrapper style" }), value: style, onChange: (value) => {
                upsertProp('style', value);
                return value;
            }, items: wrapperStyles }),
        React.createElement(FormControl.Input, { name: "searchPlaceholder", label: React.createElement(T, { id: "Blocks.Herobanner.SearchPlaceholder", defaultMessage: "Search placeholder" }), value: searchPlaceholder, placeholder: $t({
                id: 'Generics.SearchDotDotDot',
                defaultMessage: 'Search...',
            }), onChange: e => upsertProp('searchPlaceholder', e.target.value) }),
        React.createElement("h4", { className: "text-xl pt-1 text-content" },
            React.createElement(T, { id: "Generics.Background", defaultMessage: "Background" })),
        false && (React.createElement(FormControl.ButtonGroupSelect, { fullWidth: true, name: "backgroundType", items: [
                {
                    text: $t({ id: 'Generics.Image', defaultMessage: 'Image' }),
                    value: 'image',
                },
                {
                    text: $t({ id: 'Generics.Color', defaultMessage: 'Color' }),
                    value: 'color',
                },
            ], value: backgroundType, onChange: (value) => upsertProp('backgroundType', value) })),
        backgroundType === 'color' && (React.createElement(React.Fragment, null,
            React.createElement(FormControl.BackgroundColorPicker, { name: "backgroundColor", value: backgroundColor, onChange: style => {
                    upsertProps({
                        backgroundColor: style === null || style === void 0 ? void 0 : style.background,
                        textColor: style === null || style === void 0 ? void 0 : style.textColor,
                    });
                } }))),
        backgroundType === 'image' && (React.createElement(React.Fragment, null,
            React.createElement(FormControl, null,
                React.createElement(FormControl.Label, null,
                    React.createElement(T, { id: "Generics.BackgroundImage", defaultMessage: "Background image" })),
                React.createElement(ImagePickerBlockField, { image: image, removable: true, tabs: ['upload', 'unsplash', 'link'], onChange: img => {
                        upsertProp('image', img);
                    } })),
            React.createElement(FormControl.Select, { name: "imagePosition", label: React.createElement(T, { id: "Generics.BackgroundImagePosition", defaultMessage: "Background image position" }), items: bgImagePositions, value: imagePosition, onChange: (value) => upsertProp('imagePosition', value) }),
            React.createElement(FormControl.ButtonGroupSelect, { name: "textColor", label: React.createElement(T, { id: "Generics.TextColor", defaultMessage: "Text color" }), fullWidth: true, items: [
                    {
                        text: $t({ id: 'Generics.Light', defaultMessage: 'Light' }),
                        value: 'light',
                    },
                    {
                        text: $t({ id: 'Generics.Dark', defaultMessage: 'Dark' }),
                        value: 'dark',
                    },
                ], value: textColor, onChange: (value) => upsertProp('textColor', value) }),
            React.createElement(FormControl.Slider, { label: React.createElement(T, { id: "Generics.BackgroundImageTint", defaultMessage: "Background image tint" }), min: 0, max: 80, step: 5, name: "imageTintOpacity", value: imageTintOpacity, onChange: value => upsertProp('imageTintOpacity', value) })))));
};
//# sourceMappingURL=Settings.js.map